import React from 'react';
import { motion } from 'framer-motion';
type WaveformProps = {
  bars?: number;
  className?: string;
  barClassName?: string;
  animated?: boolean;
  /** seed heights between 0 and 1 are generated deterministically */
  maxHeight?: number;
};
/** Deterministic pseudo-random heights so SSR/renders stay stable */
function seededHeights(count: number): number[] {
  const heights: number[] = [];
  let seed = 7;
  for (let i = 0; i < count; i++) {
    seed = seed * 16807 % 2147483647;
    const v = 0.25 + seed % 1000 / 1000 * 0.75;
    heights.push(v);
  }
  return heights;
}
export function Waveform({
  bars = 20,
  className = '',
  barClassName = 'bg-teal-400',
  animated = true,
  maxHeight = 100
}: WaveformProps) {
  const heights = seededHeights(bars);
  return <div className={`flex items-center gap-[3px] ${className}`} aria-hidden="true" data-id="element-364">
      {heights.map((h, i) => {
      const base = h * maxHeight;
      return animated ? <motion.span key={i} className={`w-[3px] flex-none rounded-full ${barClassName}`} style={{
        height: `${base}%`
      }} animate={{
        height: [`${base * 0.4}%`, `${base}%`],
        opacity: [0.5, 1]
      }} transition={{
        duration: 0.9 + i % 5 * 0.18,
        repeat: Infinity,
        repeatType: 'mirror',
        ease: 'easeInOut',
        delay: i % 7 * 0.12
      }} data-id="element-365" /> : <span key={i} className={`w-[3px] flex-none rounded-full ${barClassName}`} style={{
        height: `${base}%`
      }} data-id="element-366" />;
    })}
    </div>;
}